import { createSlice } from "@reduxjs/toolkit";
import { Notification, User } from "utils/types/user";

export type UserState = {
  readonly currentUser: User | null;
  readonly notifications: Notification[] | null;
  readonly isLoading: boolean;
  readonly error: Error | null;
  readonly isLoggedIn: boolean;
  readonly currentCountry: string;
};

const INITIAL_STATE: UserState = {
  currentUser: null,
  isLoading: false,
  error: null,
  isLoggedIn: false,
  notifications: null,
  currentCountry: "nigeria",
};

const userSlice = createSlice({
  name: "user",
  initialState: INITIAL_STATE,
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },
    setIsLoggedIn(state, action) {
      state.isLoggedIn = action.payload;
    },
    setNotifications(state, action) {
      state.notifications = action.payload;
    },
    markNotificationSeen(state, action: { payload: string }) {
      const item = state.notifications?.find((n) => n._id === action.payload);
      if (item) item.seen = true;
    },
    removeNotification(state, action: { payload: string }) {
      if (state.notifications) {
        state.notifications = state.notifications.filter((n) => n._id !== action.payload);
      }
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setCountry(state, action) {
      state.currentCountry = action.payload;
    },
    logout(state, action) {
      state.currentUser = null;
      state.isLoggedIn = false;
      state.error = null;
      state.isLoading = false;
    },
    setError(state, action) {
      state.isLoading = false;
      state.isLoggedIn = false;
      state.error = action.payload;
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice;
